import { usePropertyDescribeRequiredInspections } from '../../../../queries/PropertyFields/NonRentalLandFields';
import { MultilineTextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

interface RequiredInspectionsProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const RequiredInspections: React.FC<RequiredInspectionsProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Describe applicable required inspections';
    const [describeRequiredInspections, set_describeRequiredInspections] = usePropertyDescribeRequiredInspections(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={describeRequiredInspections}
                />
            ) : (
                <MultilineTextBox
                    id='describeRequiredInspections'
                    value={describeRequiredInspections}
                    onChange={set_describeRequiredInspections}
                    label={label}
                    required={required}
                />
            )}
        </>
    );
};
